import React from 'react'
import { clearSetupType, selectAddons, selectIsShowOption, selectSetupTypeUpdate, selectSetupUpdateId, setAddons, setIsShowOption } from '../../../features/setup/setupSlice'
import { useDispatch, useSelector } from 'react-redux'
import { CloseIcon } from '../../../assets/icons/Svg'
import Label from '../../ui/Label'
import Input from '../../ui/Input'
import { useMutationData } from '../../../hooks/api/useMutationData'
import { showToast } from '../../../toastify/Toast'
import { CreateNewAddons, UpdateAddOns } from '../../../features/setup/setupRequestBody'
import { handleApiError } from '../../../utils/handleApiError'
import DropdownBtn from '../../ui/DropdownBtn'
import { statusList } from '../../../constant/default'

export default function Addons() {

    const dispatch = useDispatch()
    const addons = useSelector(selectAddons)
    const setupTypeUpdate = useSelector(selectSetupTypeUpdate)
    const typeId = useSelector(selectSetupUpdateId)
    const isShow = useSelector(selectIsShowOption)
    const {
        createAddons,
        isLoadingCreateAddons,

        updateAddons,
        isLoadingUpdateAddons,
    } = useMutationData()
    const defaultPrice = addons.price == null || addons.price === 0
    const addonsPrice = defaultPrice ? "" : addons.price.toString();
    const isUpdateAddons = setupTypeUpdate === 'setUpAddonsUpdate'
    const headerTitle = isUpdateAddons ? 'Update add-ons' : 'Add new add-ons'
    const isComplete = !addons.addonName || addons.price === 0 || (isUpdateAddons && addons.isAvailable === undefined)
    const isLoading = isLoadingCreateAddons || isLoadingUpdateAddons
    const isDisable = isComplete|| isLoading
    const temperatureStatus =
        addons.isAvailable === undefined
        ? "Select status"
            : addons.isAvailable
        ? "Active"
            : "Inactive";
    const btnTitle = isLoading ? 
        isUpdateAddons
            ? "Updating..."
            : "Creating..."
        : isUpdateAddons
            ? "Save Update"
            : "Save"

    const handleAddons = async () => {
        try {
            if(!addons.addonName) return showToast('Addons name is required', 'error')
            if(addons.price === 0) return showToast('Price must not be 0', 'error')

            if(isUpdateAddons) {
                if(!typeId) return showToast('Missing temperature id', 'error')
                if(addons.isAvailable === undefined) return showToast("Temperature status required.", "error");

                const body: UpdateAddOns = {
                    addonName: addons.addonName,
                    price: addons.price,
                    isAvailable: addons.isAvailable,
                    isOutOfStock: false,
                }
                await updateAddons({ addonsId: typeId, body}).unwrap()
                showToast('Addons updated successfully', 'success')
            } else {
                const body: CreateNewAddons = {
                    addonName: addons.addonName,
                    price: addons.price,
                }
                await createAddons(body).unwrap()
                showToast('Addons created successfully', 'success')
            }
            dispatch(clearSetupType({ temperature: true, setupTypeId: true, setupType: true, setupTypeUpdate: true }))
        } catch (error) {
            handleApiError(error)
        }
    }

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75%] lg:max-w-[45%] lg:mx-auto'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-sm items-start font-semibold leading-tight text-slate-900">
                                    {headerTitle}
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    onClick={() => dispatch(clearSetupType({ 
                                        temperature: true, 
                                        setupTypeId: true, 
                                        setupType: true, 
                                        setupTypeUpdate: true, 
                                        addons: true 
                                    }))}
                                >
                                    <CloseIcon/>
                                </button>
                            </div>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='py-2 space-y-3'>
                            <div className='grid grid-cols-1 gap-3'>
                                <div className=''>
                                    <Label label={'Add-ons name *'}/>
                                    <Input
                                        type={'text'}
                                        value={addons.addonName}
                                        onChange={(e) => dispatch(setAddons({ addonName: e.target.value }))}
                                        required
                                        // disabled={isLoading}
                                    />
                                </div>
                                <div className=''>
                                    <Label label={'Price *'}/>
                                    <Input
                                        type={'number'}
                                        value={addonsPrice}
                                        onChange={(e) => dispatch(setAddons({ price: Number(e.target.value) }))}
                                        required
                                        // disabled={isLoading}
                                    />
                                </div>
                            </div>
                            {isUpdateAddons && (
                                <div>
                                    <Label label={'Status *'}/>
                                        <div className='relative inline-block h-auto w-full'>
                                            <div className='w-full h-auto'>
                                                <DropdownBtn
                                                    label={temperatureStatus}
                                                    isOpen={isShow}
                                                    onClick={() => dispatch(setIsShowOption(!isShow))}
                                                    isCustomClass={true}
                                                    disabled={isLoading}
                                                    customClass={'flex w-full justify-between items-center font-medium rounded transition px-3  text-black py-2 space-x-2 text-sm  border border-gray-300 outline-none placeholder:text-gray-400 focus:border-black'}
                                                />
                                                {isShow && (
                                                <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-400">
                                                    {statusList.map((stat) => (
                                                        <li
                                                            key={stat.statusId}
                                                            onClick={() => {
                                                                dispatch(setAddons({ isAvailable: stat.isActive }) );
                                                                dispatch(setIsShowOption(false));
                                                            }}
                                                            className='px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-[12px] md:text-[13px] w-full'
                                                        >
                                                            {stat.status}
                                                        </li>
                                                    ))}
                                                </ul>
                                                )}
                                            </div>
                                        </div>
                                </div>
                            )}
                        </div>
                        <button 
                            onClick={handleAddons}
                            disabled={isDisable}
                            className={`w-full text-xs px-2 py-1.5 rounded font-medium transition-all shadow-md bg-cbColor
                                ${isComplete ? 'cursor-not-allowed bg-gray-200 border text-black' :  !isLoading ? 'text-white' : 'text-white'}
                            `}
                        >
                            {btnTitle}
                        </button> 
                    </div>
                </div>
            </div>
        </div>
    )
}
